import { z } from "zod";
import {
  emailField,
  confirmEmailField,
  firstNameField,
  lastNameField,
} from "@core/schemas/fields";
import { withEmailConfirmation } from "@core/schemas/refinements";

/** What the newsletter form asks for. */
export const newsletterSchema = withEmailConfirmation(
  z.object({
    firstName: firstNameField,
    lastName: lastNameField,
    email: emailField,
    confirmEmail: confirmEmailField,
  })
);

export type NewsletterFormData = z.infer<typeof newsletterSchema>;
